import { lazy } from "react";

export const APP_ROUTES = [
  {
    path: "/:environment/:accountId",
    component: lazy(() => import("pages/Preview")),
    title: "Activate Preview",
    subtitle: "See how activate offers behave and display",
  },
];

export default APP_ROUTES;
